import { lazy } from 'react'

export const OnePlanForEveryoneVariant1 = lazy(
  () => import('./OnePlanForEveryoneVariant1'),
)
